export const constent = {
  SEND_BUTTON: "Send Email",
  LEVEL: "Add additional email addresses",
  CANCLE_BUTTON:"Clear",
  SHOW_MESSAGE_TITLE:"Email successfully sent to the following recipient"
};
